


import { useRef, useEffect, useState } from "react";
import { fetchOurTeamData } from "../../services/api";

const Base_URL = process.env.REACT_APP_Base_URL;

const getImageUrl = (img, fallbackImg = null) => {
  if (Array.isArray(img)) img = img[0];
  if (Array.isArray(fallbackImg)) fallbackImg = fallbackImg[0];
  const extractUrl = (image) => {
    if (!image) return null;
    return image.formats?.large?.url || image.formats?.medium?.url ||
  image.url || null;
  };
  const url = extractUrl(img) || extractUrl(fallbackImg);
  return url ? `${Base_URL}${url}` : "/fallback.jpg";
};

export default function OurTeamDetail({ lang = "en" }) {
  const [data, setData] = useState(null);
  const [enData, setEnData] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const panelRef = useRef(null);

  useEffect(() => {
    fetchOurTeamData("en").then((res) => {
      if (res) setEnData(Array.isArray(res) ? res[0] : res);
    });
  }, []);

  useEffect(() => {
    setData(null);
    fetchOurTeamData(lang)
      .then((res) => {
        const d = Array.isArray(res) ? res[0] : res;
        if (d) setData(d);
        else fetchOurTeamData("en").then((fb) => {
          const fd = Array.isArray(fb) ? fb[0] : fb;
          if (fd) setData(fd);
        });
      })
      .catch(() => fetchOurTeamData("en").then((fb) => {
        const fd = Array.isArray(fb) ? fb[0] : fb;
        if (fd) setData(fd);
      }));
  }, [lang]);

  useEffect(() => {
    if (activeId && panelRef.current) {
      panelRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [activeId]);
useEffect(() => {
  if (activeId) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
   return () => {
    document.body.style.overflow = "auto";
  };
}, [activeId]);
  if (!data || !enData) return <p className="p-6">Loading...</p>;

  const activeItem = data.Our_Team?.find((m) => m.id === activeId);

  return (
    <div className="padding-x-40 padding-b-80 our-team-home">
 
      {/* Cards */}
      <div className="custom-lg-flex flex flex-wrap padding-top-40 justify-between items-start">
        {data?.Our_Team?.map((item, index) => {
          const enItem =
            enData?.Our_Team?.find((en) => en.id === item.id) ||
            enData?.Our_Team?.[index];

          return (
            <div
              key={item.id}
              onClick={() => setActiveId(activeId === item.id ? null : item.id)}
              className="w-[48%] md:w-[31.5%] 3xl:w-[15%] flex flex-wrap items-end justify-center md:pb-0 py-5 cursor-pointer"
              onMouseEnter={(e) => e.currentTarget.style.opacity = "0.8"}
              onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
            >
              <div className="w-full">
                <img
                  className="hidden md:block"
                  src={getImageUrl(item.team_image, enItem?.team_image)}
                  alt={item.team_member_name}
                  style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                />
                <img
                  className="md:hidden"
                  src={getImageUrl(item.mobile_image, enItem?.mobile_image)}
                  alt={item.team_member_name}
                  style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                />
                <h5 className="size-h5 pt-5" style={{ color: "rgba(25,175,225,1)", marginBottom: "0" }}>
                  {item.team_member_name}
                </h5>
                <p className="font-medium text-dark-blue-color pt-1 pb-2.5">
                  {item.team_member_designation}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Backdrop */}
      {activeItem && (
        <div
          style={{ position: "fixed", inset: 0, zIndex:99 }}
          onClick={() => setActiveId(null)}
        />
      )}

      {/* Profile Panel */}
      {activeItem && (
        <div className="lg:flex team-popup" ref={panelRef}>

          {/* Close Button */}
          <button
            onClick={() => setActiveId(null)}
            style={{ position: "absolute", top: "20px", right: "20px", cursor: "pointer", zIndex: 1 }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M9.58854 11.6302L2.44271 18.776C2.17535 19.0434 1.83507 19.1771 1.42187 19.1771C1.00868 19.1771 0.668402 19.0434 0.401041 18.776C0.13368 18.5087 0 18.1684 0 17.7552C0 17.342 0.13368 17.0017 0.401041 16.7344L7.54688 9.58854L0.401041 2.44271C0.13368 2.17535 0 1.83507 0 1.42187C0 1.00868 0.13368 0.668402 0.401041 0.401041C0.668402 0.13368 1.00868 0 1.42187 0C1.83507 0 2.17535 0.13368 2.44271 0.401041L9.58854 7.54688L16.7344 0.401041C17.0017 0.13368 17.342 0 17.7552 0C18.1684 0 18.5087 0.13368 18.776 0.401041C19.0434 0.668402 19.1771 1.00868 19.1771 1.42187C19.1771 1.83507 19.0434 2.17535 18.776 2.44271L11.6302 9.58854L18.776 16.7344C19.0434 17.0017 19.1771 17.342 19.1771 17.7552C19.1771 18.1684 19.0434 18.5087 18.776 18.776C18.5087 19.0434 18.1684 19.1771 17.7552 19.1771C17.342 19.1771 17.0017 19.0434 16.7344 18.776L9.58854 11.6302Z" fill="#004098"/>
            </svg>
          </button>

          {/* Left */}
          <div className="w-[100%] lg:w-[30%] p-[20px] flex flex-col">
            <img
              className="order-2 lg:order-none"
              src={getImageUrl(activeItem.team_image)}
              alt={activeItem.team_member_name}
              style={{ width: "100%", borderRadius: "10px" }}
            />
            <div className="order-1 lg:order-none">
              <h5 className="size-h5 md:pt-5" style={{ color: "rgba(25,175,225,1)", marginBottom: "0" }}>
                {activeItem.team_member_name}
              </h5>
              <p className="font-medium text-dark-blue-color pt-1 pb-2.5">
                {activeItem.team_member_designation}
              </p>
            </div>
          </div>

          <hr className="md:none" style={{ margin: "20px 20px 10px 20px", border: "none", borderTop: "1px solid rgba(25, 175, 225, 1)" }} />

          {/* Right */}
          <div
            className="panel-right my-[0] mx-[20px] md:m-[20px] lg:pl-10 md:py-5 lg:pr-[80px]"
            style={{ flex: 1,  }}
          >
            <h5 className="country-map-text mb-5" style={{ color: "rgba(25,175,225,1)" }}>
               {lang === "ja" ? "について" : "About"}  {activeItem.team_member_name}
            </h5>
            <p className="text-dark-blue-color size-h5">
              {activeItem.About_Team_Member}
            </p>

            <a
              href={activeItem.View_LinkedIn_url}
              target="_blank"
              rel="noreferrer"
              className="text-accent-blue underline size-h5 pb-5"
            >
              {activeItem.View_LinkedIn_Text}
            </a>

            {/* Q&A */}
         {Array.isArray(activeItem.Get_To_Know_More) && activeItem.Get_To_Know_More.length > 0 && (
  <>
    <hr style={{ margin: "40px 0 10px 0", border: "none", borderTop: "1px solid rgba(25, 175, 225, 1)" }} />
    <p className="country-map-text text-accent-blue">
      {activeItem.Get_To_Know_Team_Member}
    </p>
    {activeItem.Get_To_Know_More.map((qa, i) => (
      <div key={i} style={{ marginTop: "12px" }}>
        <p className="size-h5 text-dark-blue-color" style={{ fontWeight: 700, marginBottom: "0" }}>
          {qa.Question}
        </p>
        <p className="size-h5 text-dark-blue-color">
          {qa.Answer}
        </p>
      </div>
    ))}
  </>
)}
          </div>

        </div>
      )}
    </div>
  );
}